// extracted by mini-css-extract-plugin
export var content = "_pt-1";
export var noScroll = "_pt-3";
export var paper = "_pt-0";
export var scrollable = "_pt-2";